type CardParameters = {
  width: number;
  gap: number;
};

export const getCardsOverflow = (
  cardsNumber: number,
  cardParameters: CardParameters,
  containerWidth: number,
) =>
  cardParameters.width * cardsNumber + cardParameters.gap * (cardsNumber - 1) >
  containerWidth;
